export type env = "localhost" | "stage" | "prod";

export type T_ENVIRONMENT_VAR = {
  API_URL: string;
  API_KEY: string;
  COOKIE_DOMAIN: string;
  MAXCORE_DOMAIN_V1: string;
  COOKIE_TOKEN: string;
  COOKIE_DATA: string;
  NODE_ENV: env;
  VERSION: string | undefined;
  MAP_KEY: string;
  REMAX_DOMAIN: string;
  SENTRY_DSN: string;
  SENTRY_ENABLE_LOCAL?: boolean;
  PLAY_STORE_URL?: string;
  APP_STORE_URL?: string;
};

const ENVIRONMENT_VAR: T_ENVIRONMENT_VAR = {
  API_URL: import.meta.env.VITE_API_URL as string,
  API_KEY: `${import.meta.env.VITE_API_KEY}$2`,
  COOKIE_DOMAIN: import.meta.env.VITE_COOKIE_DOMAIN as string,
  MAXCORE_DOMAIN_V1: import.meta.env.VITE_MAXCORE_DOMAIN_V1 as string,
  COOKIE_TOKEN: import.meta.env.VITE_COOKIE_TOKEN as string,
  COOKIE_DATA: import.meta.env.VITE_COOKIE_DATA as string,
  NODE_ENV: import.meta.env.VITE_ENV as env,
  VERSION: import.meta.env.APP_VERSION,
  MAP_KEY: import.meta.env.VITE_MAP_KEY ?? "",
  REMAX_DOMAIN: import.meta.env.VITE_REMAX_DOMAIN as string,
  SENTRY_DSN: (import.meta.env.VITE_SENTRY_DSN as string) ?? "",
  SENTRY_ENABLE_LOCAL: false
};

export default ENVIRONMENT_VAR;
